import Link from 'next/link';
import { CMS } from '@/types/CMS';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useCallback, useState } from 'react';

const MobileNavLink = ({ item }: { item: CMS.Global.Menu }) => {
    const hasSubMenu = item && item.items && item.items.length > 0;

    const [open, setOpen] = useState<boolean>(false);

    const menuItem = useCallback(() => {
        if (!item) {
            return null;
        }
        if (hasSubMenu) {
            return (
                <div>
                    <div
                        className="flex justify-between items-center"
                        onClick={() => {
                            setOpen(!open);
                        }}>
                        {item.title}
                        <motion.div className="mt-[5px]" animate={{ transform: !open ? 'rotate(0deg)' : 'rotate(180deg)' }}><ChevronDownIcon className="w-[30px]" /></motion.div>
                    </div>
                    <motion.div animate={{ height: open ? 'fit-content' : 0, opacity: open ? 1 : 0, marginTop: open ? 12 : 0 }}>
                        <div className="flex flex-wrap text-[16px] justify-between">
                            {item.items?.map((subItem) => {
                                return (
                                    <div key={subItem.id} className="w-[40%]">
                                        <Link href={subItem.path} target={subItem.external ? '_blank' : undefined} className="block font-[500] py-[4px] text-grey10">
                                            {subItem.title}
                                        </Link>
                                        {subItem.items && subItem.items.length > 0 && (
                                            <div className="gap-[6px] py-[12px]">
                                                {subItem.items?.map((subSubItem) => {
                                                    return (
                                                        <div key={subSubItem.id}>
                                                            <Link href={subSubItem.path} target={subSubItem.external ? '_blank' : undefined} className="text-gray-500 py-[6px] block font-[400]">
                                                                {subSubItem.title}
                                                            </Link>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </motion.div>
                </div>
            );
        }
        return (
            <Link href={item.path} target={item.external ? '_blank' : undefined}>
                {item.title}
            </Link>
        );
    }, [hasSubMenu, item, open]);

    return <li key={item.id} className="font-secondary text-[#475467] capitalize font-[400] text-[20px] mb-[34px]">{menuItem()}</li>;
};
export default MobileNavLink;
